import { config } from './config';

export const userLocationRadius = () => ({
  type: 'fill',
  paint: {
    'fill-color': 'rgba(237, 127, 21, 0.2)'
  }
});

export const pathLayerAsLine = (accParam, edgeTypeParam) => ({
  type: 'line',
  filter:[
    'all',
    ['!=', ['get', edgeTypeParam], 'bus'],
    ['!=', ['get', edgeTypeParam], 'ferry'],
  ],
  paint: {
    'line-color': [
      'case',
      ['==', ['get', accParam], 0], '#78909c',
      ['==', ['get', accParam], 1], '#4caf50',
      ['==', ['get', accParam], 2], '#ffa726',
      ['==', ['get', accParam], 3], '#ffa726',
      ['==', ['get', accParam], 4], '#ef5350',
      '#78909c'
    ],
    'line-dasharray':[
      1, 3
    ],
    'line-width': 5
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  }
});

export const lightPathLayerAsLine = (accParam, edgeTypeParam) => ({
  type: 'line',
  filter:[
    'all',
    ['!=', ['get', edgeTypeParam], 'bus'],
    ['!=', ['get', edgeTypeParam], 'ferry'],
  ],
  paint: {
    'line-color': [
      'case',
      ['==', ['get', accParam], 0], '#f6f8f9',
      ['==', ['get', accParam], 1], '#1ccb20',
      ['==', ['get', accParam], 2], '#ffa726',
      ['==', ['get', accParam], 3], '#ffa726',
      ['==', ['get', accParam], 4], '#ef5350',
      '#f6f8f9'
    ],
    'line-dasharray':[
      1, 3
    ],
    'line-width': 5
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  }
});


export const pathUnderBusLayerAsLine = (edgeTypeParam) => ({
  type: 'line',
  filter:[
    'all',
    ['match', ['get', edgeTypeParam], ['bus', 'ferry'], true, false],
  ],
  paint: {
    'line-color': [
      'case',
      ['==', ['get', edgeTypeParam], 'bus'], '#5d656b' ,
      ['==', ['get', edgeTypeParam], 'ferry'], '#5d656b',
      '#555555'
    ],
    'line-width': 9
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  }
});


export const pathBusLayerAsLine = (edgeTypeParam, color) => ({
  type: 'line',
  filter:[
    'all',
    ['match', ['get', edgeTypeParam], ['bus', 'ferry'], true, false],
  ],
  paint: {
    'line-color': [
      'case',
      ['==', ['get', edgeTypeParam], 'tramway'], '#4e86ed',
      ['==', ['get', edgeTypeParam], 'bus'], ['get', color],
      ['==', ['get', edgeTypeParam], 'ferry'], ['get', color],
      '#555555'
    ],
    'line-width': 6
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  }
});


export const selectedPathSection = () => ({
  type: 'line',
  paint: {
    'line-color': '#51C7FB',
    'line-width': 6
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  }
});

export const selectedPathGraph = () => ({
  type: 'line',
  paint: {
    'line-color': 'cyan',
    'line-width': 6
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  }
});

export const unselectedPathLayer = (lineWidth) => ({
  type: 'line',
  paint: {
    'line-color': '#9a9a9a',
    'line-width': lineWidth,
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  }
});

export const underUnselectedPathLayer = (lineWidth) => ({
  type: 'line',
  maxzoom: 19,
  paint: {
    'line-color': '#5b5b5b',
    'line-width': lineWidth + 2
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  }
});

export const selectedTransportLineLayer = (lineWidth) => ({
  type: 'line',
  paint: {
    'line-color': '#51C7FB',
    'line-width' : lineWidth
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round',
  }
});

export const obstaclesSymbolLayer = () => ({
  id: 'symbols',
  type: 'symbol',
  layout: {
    'icon-image': 'bus-simple-solid-grey-white', // Using property from GeoJSON
    'icon-size': [
      'interpolate',
      ['linear'],
      ['zoom'],
      10, 0.4,   // 0.5 times the size at zoom level 10
      15, 0.5    // 2 times the size at zoom level 15
    ],
    'icon-allow-overlap': true
  }
});

export const orthoPicto = `${config.url.PUBLIC_URL}/ortho.jpeg`;
export const osmPicto = `${config.url.PUBLIC_URL}/osm_picto.png`;